import { Link } from "react-router-dom";
import { Cookie, Mail, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

const SECTIONS = [
    {
        n: "1",
        title: "Premessa",
        body: (
            <>
                <p>La presente Cookie Policy descrive le modalità di utilizzo dei cookie e di tecnologie analoghe da parte della piattaforma <strong>CondominioNow – L'esperto risponde</strong>, servizio informativo gratuito sviluppato e gestito da <strong>Nowgestioni S.r.l.</strong></p>
                <p className="mt-3">L'accesso e la navigazione sulla piattaforma comportano la presa visione della presente informativa.</p>
            </>
        ),
    },
    {
        n: "2",
        title: "Titolare del trattamento",
        body: (
            <p>
                <strong>Nowgestioni S.r.l.</strong>
                <br />
                Legale Rappresentante: <strong>Dott. Luigi Colaianni</strong>
                <br />
                Email: <a href="mailto:info@nowgestioni.it" className="text-primary hover:underline">info@nowgestioni.it</a>
            </p>
        ),
    },
    {
        n: "3",
        title: "Cosa sono i cookie",
        body: (
            <p>I cookie sono piccoli file di testo che i siti web inviano al dispositivo dell'utente per consentire il corretto funzionamento dei servizi, migliorare l'esperienza di navigazione e garantire la sicurezza delle operazioni effettuate.</p>
        ),
    },
    {
        n: "4",
        title: "Cookie utilizzati da CondominioNow",
        body: (
            <>
                <p>CondominioNow utilizza <strong>esclusivamente cookie tecnici, funzionali e di sicurezza</strong> strettamente necessari al corretto funzionamento della piattaforma.</p>
                <p className="mt-3">Tra questi possono rientrare:</p>
                <ul className="mt-3 space-y-1.5 list-disc pl-5">
                    <li>cookie di autenticazione;</li>
                    <li>cookie di sessione;</li>
                    <li>cookie necessari alla gestione del login;</li>
                    <li>cookie necessari al mantenimento della sessione utente;</li>
                    <li>cookie di sicurezza;</li>
                    <li>cookie necessari alla corretta erogazione delle funzionalità richieste dall'utente.</li>
                </ul>
                <p className="mt-3">Tali cookie non richiedono il consenso preventivo dell'utente in quanto indispensabili all'erogazione del servizio richiesto.</p>
            </>
        ),
    },
    {
        n: "5",
        title: "Assenza di cookie pubblicitari e di profilazione",
        body: (
            <>
                <p>Alla data di pubblicazione della presente informativa:</p>
                <ul className="mt-3 space-y-1.5 list-disc pl-5">
                    <li>non vengono utilizzati cookie pubblicitari;</li>
                    <li>non vengono utilizzati cookie di profilazione;</li>
                    <li>non vengono effettuate attività di marketing comportamentale;</li>
                    <li>non vengono creati profili commerciali degli utenti;</li>
                    <li>non vengono venduti dati personali a terzi.</li>
                </ul>
            </>
        ),
    },
    {
        n: "6",
        title: "Finalità dei cookie",
        body: (
            <>
                <p>I cookie tecnici utilizzati perseguono esclusivamente finalità legittime e necessarie al funzionamento della piattaforma, tra cui:</p>
                <ul className="mt-3 space-y-1.5 list-disc pl-5">
                    <li>accesso alle aree riservate;</li>
                    <li>autenticazione degli utenti;</li>
                    <li>sicurezza degli account;</li>
                    <li>protezione da accessi non autorizzati;</li>
                    <li>prevenzione di attività fraudolente;</li>
                    <li>corretta gestione delle sessioni utente;</li>
                    <li>stabilità e funzionalità del sistema.</li>
                </ul>
            </>
        ),
    },
    {
        n: "7",
        title: "Cookie di terze parti",
        body: (
            <>
                <p>Alla data di pubblicazione della presente Cookie Policy la piattaforma <strong>non utilizza cookie di profilazione di terze parti</strong>.</p>
                <p className="mt-3">Qualora in futuro venissero integrati strumenti esterni, servizi statistici o piattaforme di terze parti che comportino l'utilizzo di cookie aggiuntivi, la presente informativa verrà aggiornata e saranno adottati tutti gli adempimenti richiesti dalla normativa vigente.</p>
            </>
        ),
    },
    {
        n: "8",
        title: "Gestione dei cookie",
        body: (
            <>
                <p>L'utente può configurare il proprio browser per:</p>
                <ul className="mt-3 space-y-1.5 list-disc pl-5">
                    <li>visualizzare i cookie presenti;</li>
                    <li>cancellare i cookie;</li>
                    <li>limitare o bloccare i cookie.</li>
                </ul>
                <p className="mt-3">La disattivazione dei cookie tecnici potrebbe impedire il corretto funzionamento della piattaforma o limitare l'accesso a una o più funzionalità.</p>
                <p className="mt-3">Nowgestioni S.r.l. non assume alcuna responsabilità per eventuali malfunzionamenti derivanti dalla disattivazione dei cookie tecnici indispensabili.</p>
            </>
        ),
    },
    {
        n: "9",
        title: "Limitazione di responsabilità",
        body: (
            <>
                <p>Nowgestioni S.r.l. e il Dott. Luigi Colaianni adottano misure ragionevoli e proporzionate per garantire il corretto funzionamento della piattaforma e la sicurezza dei sistemi utilizzati.</p>
                <p className="mt-3">Tuttavia, nei limiti consentiti dalla legge, non possono garantire l'assenza assoluta di interruzioni, malfunzionamenti tecnici, accessi non autorizzati, eventi di forza maggiore o circostanze non direttamente controllabili.</p>
                <p className="mt-3">L'utilizzo della piattaforma avviene sotto la responsabilità dell'utente.</p>
            </>
        ),
    },
    {
        n: "10",
        title: "Modifiche alla Cookie Policy",
        body: (
            <>
                <p>Nowgestioni S.r.l. si riserva il diritto di aggiornare, modificare o integrare la presente Cookie Policy in qualsiasi momento.</p>
                <p className="mt-3">Le modifiche saranno pubblicate sulla presente pagina e diventeranno efficaci dalla data di pubblicazione.</p>
            </>
        ),
    },
    {
        n: "11",
        title: "Contatti",
        body: (
            <>
                <p>Per qualsiasi informazione relativa alla presente Cookie Policy è possibile contattare:</p>
                <p className="mt-3">
                    <strong>CondominioNow – L'esperto risponde</strong>
                    <br />
                    Un servizio di Nowgestioni S.r.l.
                    <br />
                    Email: <a href="mailto:info@nowgestioni.it" className="text-primary hover:underline">info@nowgestioni.it</a>
                </p>
            </>
        ),
    },
    {
        n: "12",
        title: "Trasparenza e tutela degli utenti",
        body: (
            <>
                <p>CondominioNow utilizza esclusivamente cookie e tecnologie strettamente necessarie all'erogazione del servizio e alla sicurezza della piattaforma.</p>
                <p className="mt-3">La tutela della privacy degli utenti rappresenta un principio fondamentale del progetto.</p>
            </>
        ),
    },
    {
        n: "13",
        title: "Rinvio alla Privacy Policy",
        body: (
            <p>
                Per maggiori informazioni sul trattamento dei dati personali, sulle finalità del trattamento e sui diritti degli utenti si rinvia alla <Link to="/privacy" className="text-primary hover:underline font-semibold">Privacy Policy</Link> disponibile sul sito.
            </p>
        ),
    },
    {
        n: "14",
        title: "Dichiarazione finale",
        body: (
            <>
                <p>L'utente prende atto che l'utilizzo dei cookie tecnici è indispensabile per accedere ad alcune funzionalità della piattaforma e per garantirne sicurezza, stabilità e corretto funzionamento.</p>
                <p className="mt-3">La prosecuzione della navigazione e l'utilizzo dei servizi disponibili comportano la presa visione della presente Cookie Policy.</p>
            </>
        ),
    },
];

export default function CookiePolicy() {
    return (
        <div className="bg-white">
            {/* HERO */}
            <section className="relative overflow-hidden border-b border-slate-200">
                <div
                    aria-hidden
                    className="absolute inset-0 bg-[radial-gradient(1000px_400px_at_-10%_-20%,rgba(15,76,129,0.08),transparent_60%)]"
                />
                <div className="relative mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 py-14 lg:py-20">
                    <div className="inline-flex items-center gap-2 rounded-full bg-primary/10 border border-primary/20 px-3 py-1.5 text-xs font-semibold uppercase tracking-widest text-primary" data-testid="cookie-badge">
                        <Cookie className="size-3.5" /> Solo cookie tecnici · Nessuna profilazione
                    </div>
                    <h1
                        data-testid="cookie-title"
                        className="mt-5 font-serif text-4xl sm:text-5xl lg:text-6xl font-semibold leading-tight tracking-tight text-slate-900"
                    >
                        Cookie Policy
                    </h1>
                    <p className="mt-4 text-lg text-slate-600 max-w-2xl leading-relaxed">
                        CondominioNow utilizza <strong>esclusivamente cookie tecnici, funzionali e di sicurezza</strong> necessari al corretto funzionamento della piattaforma.
                    </p>
                    <p className="mt-2 text-sm text-muted-foreground" data-testid="cookie-updated">
                        Ultimo aggiornamento: <strong>Agosto 2026</strong>
                    </p>
                </div>
            </section>

            {/* CONTENT */}
            <section className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 py-14 lg:py-20">
                <div className="grid gap-6 lg:grid-cols-[260px_1fr]">
                    {/* Sticky index */}
                    <aside className="hidden lg:block">
                        <div className="sticky top-24">
                            <div className="text-xs uppercase tracking-widest text-slate-500 font-semibold mb-3">Indice</div>
                            <ol className="space-y-1.5 text-sm">
                                {SECTIONS.map(s => (
                                    <li key={s.n}>
                                        <a href={`#sez-${s.n}`} className="flex items-start gap-2 text-slate-600 hover:text-primary transition py-0.5">
                                            <span className="text-slate-400 font-mono text-xs w-5 shrink-0">{s.n}.</span>
                                            <span className="leading-snug">{s.title}</span>
                                        </a>
                                    </li>
                                ))}
                            </ol>
                        </div>
                    </aside>

                    {/* Sections */}
                    <article className="min-w-0" data-testid="cookie-content">
                        <div className="space-y-8">
                            {SECTIONS.map(s => (
                                <section
                                    key={s.n}
                                    id={`sez-${s.n}`}
                                    className="scroll-mt-24 rounded-2xl border border-slate-200 bg-white p-6 lg:p-8 shadow-[0_1px_2px_0_rgba(0,0,0,0.04)]"
                                    data-testid={`cookie-section-${s.n}`}
                                >
                                    <div className="flex items-start gap-4">
                                        <div className="shrink-0 size-10 rounded-xl bg-primary/10 flex items-center justify-center">
                                            <span className="font-serif text-lg font-semibold text-primary">{s.n}</span>
                                        </div>
                                        <div className="min-w-0 flex-1">
                                            <h2 className="font-serif text-2xl font-semibold text-slate-900 leading-tight">{s.title}</h2>
                                            <div className="mt-3 text-slate-700 leading-relaxed text-[15px]">{s.body}</div>
                                        </div>
                                    </div>
                                </section>
                            ))}
                        </div>

                        {/* Contact CTA */}
                        <div className="mt-10 rounded-2xl bg-slate-950 text-white p-8 lg:p-10" data-testid="cookie-contact-cta">
                            <div className="flex items-start gap-4 flex-wrap">
                                <div className="size-12 rounded-xl bg-white/10 border border-white/15 flex items-center justify-center shrink-0">
                                    <Mail className="size-5 text-amber-400" />
                                </div>
                                <div className="flex-1 min-w-0">
                                    <h3 className="font-serif text-2xl font-semibold">Hai domande sui cookie?</h3>
                                    <p className="mt-2 text-slate-300 text-sm">
                                        Scrivici a <a href="mailto:info@nowgestioni.it" className="text-amber-300 underline underline-offset-4 hover:text-amber-200">info@nowgestioni.it</a> — leggi anche la <Link to="/privacy" className="text-amber-300 underline underline-offset-4 hover:text-amber-200">Privacy Policy</Link> e i <Link to="/termini" className="text-amber-300 underline underline-offset-4 hover:text-amber-200">Termini di servizio</Link>.
                                    </p>
                                </div>
                                <Button asChild size="lg" className="bg-accent text-accent-foreground hover:bg-accent/90 font-semibold rounded-full">
                                    <Link to="/come-funziona">Scopri come funziona <ArrowRight className="size-4 ml-1" /></Link>
                                </Button>
                            </div>
                        </div>
                    </article>
                </div>
            </section>
        </div>
    );
}
